/* global angular */

/**
 * @doc module
 * @id UserModule
 * @description UserModule
 *
 */
angular.module('gc.user', ['gc.services', 'angular-jwt', 'gc.localstorage'])
.factory('GraphLogin', [
  function () {
    var auth = false

    var graphlogin =  {}

    graphlogin.get = function() {
      return auth
    }

    graphlogin.setAuth = function(data) {
      auth = data
    }

    return graphlogin;
  },
  
])
.factory('GcUser', [
'$http',
'$rootScope',
'$q',
'$log',
'$window',
'$timeout',
'API_URL',
'CommentService',
'PostMessageService',
'Utils',
'jwtHelper',
'LocalStorageService',
'GraphLogin',
'$document',
'GRAPHLOGIN_URL',
function ($http, $rootScope, $q, $log, $window, $timeout, API_URL, CommentService, PostMessageService, Utils, jwtHelper, LocalStorageService, GraphLogin, $document, GRAPHLOGIN_URL) {
  'use strict';

  var User = {
    website_id: Utils.getParameterByName('website_id') || 'dev-site-graphcomment'
  };

  var knownUsers = {};
  var userObject = null;
  var guestObject = null;
  var unreadNotification = 0;
  var defaultLang = "en";
  var usersApiUrl = API_URL + '/users';
  var isOrange = window.location.hostname.indexOf('orange.fr') !== -1; 
  
  /**
   * Must call when starting the web app
   * @return {null} [description]
   */
  User.init = function (cb) {
    var guest = LocalStorageService.getItem('guest');
    if (guest) User.setGuest(typeof guest === 'object' ? guest : JSON.parse(guest));
    
  var req = {
    method: 'GET',
    url: usersApiUrl + '/me?website=' + this.website_id + '&plateform=front',
  };

  if(!CommentService.website.sso.active && CommentService.website.custom_client !== 'orange') {

    var scriptElement = $document[0].createElement('script');
    scriptElement.src = GRAPHLOGIN_URL;

    scriptElement.onload = function() {

      const graphlogin =  $window.__semio__graphlogin;

      GraphLogin.setAuth(graphlogin({
        key: Utils.getParameterByName('website_id') || 'dev-site-graphcomment'
      }))

      GraphLogin.get().subscribeToToken( token => {
        User.refresh(token);
      })

      if(GraphLogin.get().readToken())
        User.refresh(GraphLogin.get().readToken());

      if (!CommentService.website.sso.active || !CommentService.website.sso.unidirectional) {
        User.checkTokenInUrl();
      }
      
      setTimeout(function(){ return User.fetchUser(req, cb),1000 });
    };

    $document[0].body.appendChild(scriptElement);
  } else {
    if (!CommentService.website.sso.active || !CommentService.website.sso.unidirectional) {
      User.checkTokenInUrl();
    }
    setTimeout(function(){
      return User.fetchUser(req, cb)
    },1000)
  }
  };


  User.fetchUser = function (req, cb) {
    return $http(req).then(function (resp) {
        
      if (resp.data.gcCode && resp.data.gcCode === 410) {
        User.setUser(null);
        LocalStorageService.removeToken();
        LocalStorageService.removeItem('gc_user');
        cb();
       
      } else {
        User.setUser(resp.data);
        User.canModerate(resp.data);
        cb(resp.data);
      }
    }).catch(() => {
      User.setUser(null);
      LocalStorageService.removeToken();
      LocalStorageService.removeItem('gc_user');
      cb();
    });
  }

  /**
   * Set the User Object variable
   * @param {null} user
   */
  User.setUser = function (user) {
    userObject = user;
   
    $rootScope.gcUser = user;

    $rootScope.gcUserHasPrivileges = User.hasPrivileges();
    $rootScope.gcUserIsAdmin = User.isOwner() || User.isAdministrator();

    if (window.parent) {
      PostMessageService.postMessage('gc-user-data', { user });
    }

    if (user === null) {
      $rootScope.$broadcast('logged_out', null);
    } else {
      $rootScope.$broadcast('logged_in', userObject);
      $rootScope.$broadcast('user:change', userObject);
    }
  };

  /**
   * Check if user has permission to moderate comments
   */
  User.canModerate = function (user) {
    $http({
      method: 'GET',
      url: API_URL + '/users/website/' + this.website_id + '/can_moderate'
    })
      .success(function (resp) {
        userObject.can_moderate = resp.can_moderate;
      });
  };

  /**
   * Cache system to store known user
   */
  User.addKnownUser = function (user) {
    knownUsers[user._id] = user;
  };
  User.getKnownUser = function (userId) {
    return (knownUsers[userId]);
  };
  User.updateKnownUserField = function (userId, data) {
    if (knownUsers[userId]) {
      angular.extend(knownUsers[userId], data);
    }
  };


  User.setUserPicture = function (picture) {
    userObject.picture = picture + "?" + (Math.floor(Math.random() * 1000 + 1));
    User.setUser(userObject);
    User.updateCachedUser({picture: picture});
  };

  User.addNotification = function (notif) {
    unreadNotification += 1;
    userObject.notifications.unshift(notif);
  };

  User.getNotifications = function () {
    return userObject.notifications;
  };

  User.getUnreadNotifications = function () {
    return unreadNotification;
  };

  User.markNotificationsAsRead = function () {
    unreadNotification = 0;
    $http.get(API_URL + '/notifications/mark_as_read')
      .success(function (user) {
        User.setUser(user);
      }).error(function (err) {
        $log.error(err);
      });
  };

  /**
   * return the user object
   * @return {[type]} [description]
   */
  User.getUser = function () {
    return userObject;
  };

  /**
   * Refresh the user model with
   *
   * refresh() : make call to api
   * refresh(callback) : make call to api and call the callback
   * refresh(token) : extract the token
   * refresh(token, callback) : extract the token and call the callback
   *
   * @param p_one {string|function} [p_one] token or callback
   * @param p_two {function} [p_two] callback when token
   * @returns {*}
   */
  User.refresh = function (p_one, p_two) {
    var cb = function () {};
    var token = null;

    if (typeof p_one === 'function') {
      cb = p_one;
    } else if (p_one) {
      token = p_one;
      if (typeof p_two === 'function') {
        cb = p_two;
      }
    }

    function endWithUser(resp) {
      if (resp.gcCode && resp.gcCode === 410) return;

      var user = resp;
      $log.debug('user: ', user);
      User.setGuest(null);
      User.canModerate(user);
      User.setUser(user);

      // check if user has a profile, else open profile
      // and force user to fill his/her profile
      if (!user.profile_found) {
        if (CommentService.website.custom_client !== 'orange') {
          $rootScope.$broadcast('profile-popin:open', user._id, { fromMenu: true });
        }
      }

      return cb(null, user);
    }

    if (token) {
      this.setToken(token);
    }

    return $http({
      method: 'GET',
      url: usersApiUrl + '/me?website=' + this.website_id + '&plateform=front',
    })
    .success(endWithUser)
    .error(function (err) {
      return cb(err);
    });
  };

  User.setToken = function(token) {
    var finalToken = token;

    if (finalToken.substring(0, 'JWT'.length) !== 'JWT') {
      finalToken = 'JWT ' + finalToken;
    }

    if (window.parent) {
      PostMessageService.postMessage('gc-token', { gcToken: finalToken });
    }

    return LocalStorageService.setToken(finalToken);
  };

  User.getToken = function() {
    return LocalStorageService.getToken();
  };

  User.isLocallyLogged = function () {
    return userObject !== null;
  };

  User.setGuest = function (guest) {
    LocalStorageService.setItem('guest', guest);
    guestObject = guest;
    $rootScope.gcGuest = guest;
    if (guest) $rootScope.$broadcast('logged_in', {});
  };

  User.getGuest = function () {
    return User.isGuest() ? guestObject : null;
  };

  User.isGuest = function () {
    return !userObject && guestObject;
  };

  User.logout = function (disableTracking) {    
    PostMessageService.postCommand('logout');
    GraphLogin.get().logout();
    this.oldLogout(disableTracking);
   
  }

  User.oldLogout = function (disableTracking) {
    User.setUser(null);
    User.setGuest(null);
    LocalStorageService.removeToken();
    LocalStorageService.removeItem('gc_user');
    $rootScope.$broadcast('logged_out', null);
    $rootScope.orangeUser = null;
    !disableTracking && mixpanel.track('auth:logout');
    PostMessageService.postMessage('gc-token', { gcToken: null });
    // for LePhoceen
    $window.parent.postMessage(JSON.stringify({ onLogout: true }), '*');
    PostMessageService.postMessage('logged-out', {});
  };

  User.checkTokenInUrl = function() {
    // ?token is used by social logins
    var token = Utils.getParameterByName('token');
    if (token) {
      User.refresh(token, function(err, user) {
        if (err) throw err;

        // if social login
        $log.debug('Social Login [ New user: ', user, ' ]');
        mixpanel.track('auth:social_(unknown)_success');
        $rootScope.$emit('scrollTo', 0);

        // remove token in url
        var url = Utils.removeUrlParameter(window.location.href, 'token');
        window.location.href = url;
      });
    }
  };

  User.login = function (username, password, customLoginUrl) {
    return $http.post(customLoginUrl || usersApiUrl + '/login', {
      username: username,
      password: password,
      website: CommentService.website._id,
    }).then(function (resp) {
      var token = resp.data.token;

      // for LePhoceen
      if (!token && resp.data.datas) {
        if (resp.data.datas.token) {
          token = resp.data.datas.token;
        }
        $window.parent.postMessage(JSON.stringify({ onLogin: resp.data.datas }), '*');
      }

      return User.refresh(token);
    });
  };

  User.register = function (username, password, email, avatar) {
    var formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('email', email);
    formData.append('picture', avatar);
    formData.append('website', CommentService.website._id);
    formData.append('language', window.navigator.userLanguage || window.navigator.language);
    formData.append('_url', Utils.getParameterByName('url') || window.location.href);

    return $http({
      url: usersApiUrl + '/registerData',
      method: 'post',
      headers: {'Content-Type': undefined},
      data: formData,
    }).success(function (obj) {
      $log.debug('login', obj);
      User.refresh(obj.token);
    });
  };

  User.initSpup = function(cb) {
    $rootScope.spupLog('[spup] initSpup()');

    if (!$rootScope.orangeUser || !User.isLocallyLogged()) {
      $rootScope.spupLog('[spup] no spup user');

      var unbind = $rootScope.$on('spup_registered', function() {
        $rootScope.spupLog('[spup] no spup user ... done');
        cb();
        unbind();
      });

      function onCancel() {
        $rootScope.$broadcast('call_reset_spup_comment');
        //window.parent.oSpup.removeListener('cancelled', onCancel);
      }
      //window.parent.oSpup.addListener('cancelled', onCancel);

      //window.parent.oSpup.get(false);
      window.parent.postMessage({"target": "spup", "command": "get", "params": [false]}, '*');
    }

    else if ($rootScope.orangeUser.id === -1 && !User.getUser()) {
      $rootScope.spupLog('[spup] user not authenticated');
      var unbind = $rootScope.$on('spup_registered', function() {
        $rootScope.spupLog('[spup] user not authenticated ... done');
        cb();
        unbind();
      });
      window.parent.postMessage({"target": "spup", "command": "create", "params": []}, '*');
      //window.parent.oSpup.create();
    }

    else {
      $rootScope.spupLog('[spup] check multi-account');

      // in case the account on orange has changed,
      // and we're still logged in with the previous account
      if ($rootScope.orangeUser.name !== User.getUser().pseudo) {
        $rootScope.spupLog('[spup] disconnect (mutli-account)', $rootScope.orangeUser, User.getUser());
        User.logout(true);
        $timeout(function() {
          User.initSpup(cb);
        }, 0);
      } else {
        $rootScope.spupLog('[spup] everything is fine', $rootScope.orangeUser, User.getUser());
        return true;
      }
    }
  };

  User.registerSpup = function (spupUser) {
    $rootScope.spupLog('[spup] registerSpup()');

    var formData = new FormData();
    formData.append('uid', spupUser.id);
    formData.append('name', spupUser.name);
    formData.append('email', spupUser.email);
    formData.append('avatar', spupUser.avatar['142x142']);
    formData.append('status', spupUser.status.global);

    return $http({
      url: usersApiUrl + '/loginAndOrRegisterByUidAndEmail/website/' + CommentService.website._id,
      method: 'post',
      headers: { 'Content-Type': undefined },
      data: formData,
    })
      .success(function(resp) {
        $rootScope.spupLog('[spup] register', resp);
        return User.refresh(resp.token, function(err, user) {
          $rootScope.$broadcast('spup_registered');
        });
      })
    ;
  };

  User.hasSpupCookie = function() {
    return $http.post(API_URL + '/condition/orange');
  };

  User.sso = function(ssoData, cb) {
    var apiPublicKey = Utils.getParameterByName('api_public_key');
    if (!ssoData || !apiPublicKey) return;

    return $http({
      method: 'post',
      url: API_URL + '/users/sso/loginAndOrRegisterByUid/website/' + CommentService.website._id,
      headers: { Authorization: undefined },
      data: {
        key: {
          pubKey: apiPublicKey,
          auth: ssoData
        },
      }
    })
      .success(function(resp) {
        User.ssoDone = true;
        User.setToken(resp.token);
        User.init(cb);
      }.bind(this))

      .error(function(resp) {
        if (resp.err && resp.err === 'pseudo already exist, please change your pseudo') {
          $rootScope.ssoConflict = true;
          $rootScope.ssoConflictUsername = resp.username;

          // remove previous sso user (if any)
          LocalStorageService.removeToken();

          // allow parent page to know there is a problem
          PostMessageService.postMessage('gc-sso-conflict');

          console.error('[gc] SSO: ' + resp.err);
          User.ssoDone = true;
          User.init(cb);
        }
      }.bind(this))
    ;
  };

  User.isGuestBanned = function() {
    var guest = User.getGuest();
    if (!guest) return;
    var params = '?email=' + encodeURIComponent(guest.email) + '&username=' + encodeURIComponent(guest.username);
    return $http.get(API_URL + '/ban/guest/website/' + CommentService.website._id + params);
  };

  User.resetPass = function (email) {
    return $http.post(usersApiUrl + '/reset_password', {
      email: email,
      lang: document.documentElement.lang || ('navigator' in window && window.navigator.language) || 'en'
    });
  };

  User.updateCachedUser = function (objValues) {
    CommentService.updateCachedUser(userObject._id, objValues);
  };

  User.update = function (user, cb, progress) {
    var formData = new FormData();
    for (var key in user) {
      if (key === '_id') continue;
      formData.append(key, user[key]);
    }
    formData.append('_url', Utils.getParameterByName('url') || window.location.href);

    return $http({
      url: usersApiUrl + '/update',
      method: 'post',
      headers: {'Content-Type': undefined, website: CommentService.website._id },
      data: formData,
      uploadEventHandlers: {
        progress: function(e) {
          progress && progress(Math.round(e.loaded * 100 / e.total));
        }
      },
    }).success(function (response, code) {

      if(code === 200) {
        user.profile_found = true;
        User.setUser(response);
        User.updateCachedUser(response);
        return cb(null, response);
      }
      return errorUpdateMessage(response, cb)
    }).error(function (err) {
     return errorUpdateMessage(err,cb)
    });
  };

  function errorUpdateMessage(err, cb) {
    $log.debug('update error', err);
    // reformat the API return
    var message = err.err || err.msg || err.gcErr;
    if (message) {
      if (~message.indexOf('email empty or null')) {
        message = 'email empty';
      } else if (~message.indexOf('email bad format')) {
        message = 'email bad format';
      } else if (~message.indexOf('email already exist')) {
        message = 'email already exist';
      } else if (~message.indexOf('bad_extension') || ~message.indexOf('ETOOBIG')) {
        message = 'wrong profile picture';
      } else if (~message.indexOf('username already exist')) {
        message = 'username already used';
      } else if (~message.indexOf('pseudo already exist')) {
        message = 'pseudo already used';
      } else if (~message.indexOf('pseudo already used')) {
        message = 'pseudo already used';
      } else if (~message.indexOf('bio too long')) {
        message = 'bio too long';
      } else if (~message.indexOf('password invalid')) {
        message = 'Invalid password';
      } else {
        message = 'error';
      }
    } else {
      message = 'error';
    }
    
    return cb(message, null);
  }

  User.resendToken = function () {
    return $http.post(usersApiUrl + '/resend_token', {
      _url: Utils.getParameterByName('url') || window.location.href,
      website: CommentService.website._id,
    })
  };

  User.validEmail = function (email, token, cb) {
    return $http.post(usersApiUrl + '/verify_email', {
      token: token,
      email: email,
      website: CommentService.website._id,
    })
    .success(function (user) {
      User.setUser(user);
      return cb(null, user);
    })
    .error(function (err) {
      if (err && err.msg) {
        return cb(err.msg, null);
      } else {
        return cb('internal error', null);
      }
    });
  };

  var called, defaultAvatars = [];
  User.getDefaultAvatars = function () {
    if (!called) {
      called = true
      $http.get(usersApiUrl + '/default_avatars').success(function (resp) {
        angular.merge(defaultAvatars, resp.avatars);
      });
    }
    return defaultAvatars;
  };

  User.getPreferedLanguage = function () {
    return userObject === null ? defaultLang : userObject.lang;
  };

  User.hasPrivileges = function() {
    return User.isSuperAdmin() || User.isOwner() || User.isAdministrator() || User.isModerator();
  };

  User.isSuperAdmin = function() {
    return userObject && userObject.role === 'admin';
  };

  User.isOwner = function() {
    return userObject && userObject._id === CommentService.website.owner;
  };

  User.isAdministrator = function() {
    return userObject && CommentService.website.administrators && CommentService.website.administrators.indexOf(userObject._id) !== -1;
  };

  User.isModerator = function() {
    return userObject && CommentService.website.moderators && CommentService.website.moderators.indexOf(userObject._id) !== -1;
  };

  User.cancelEmailValidation = function () {
    return $http.post(usersApiUrl + '/reset_validation').success(function (user) {
      User.setUser(user);
    });
  };

  User.sendRecoTo = function(userId) {
    return $http.post(usersApiUrl + '/notifications/reco/to/' + userId + '/website/' + CommentService.website._id);
  };

  User.canSendRecoTo = function(userId) {
    return $http.get(usersApiUrl + '/notifications/check/reco/to/' + userId + '/website/' + CommentService.website._id);
  };

  return User;
}]);
